// *********** Form Data ************
import { states } from "@/common/data";

const stateOptions = states.map((datum) => ({
  value: datum.state.id,
  label: datum.state.name,
}));

export const formInputs = [
  {
    inputType: "text",
    name: "Username",
    prompt: "First Name",
    rules: { required: true },
    placeholder: "Enter First Name",
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "lastname",
    prompt: " Enter LastName",
    placeholder: "Enter Last Name",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "text",
    name: "email",
    prompt: "Email",
    placeholder: "Enter Email Address",
    rules: { required: true },
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "number",
    prompt: "Phone Number",
    placeholder: "Enter Phone Number",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "selectInput",
    name: "Email",
    prompt: "User type",
    initialValue: "user",
    options: [
      { name: "Retailer", id: 1 },
      { name: "Distributor", id: 2 },
      { name: "Manufactory", id: 3 },
    ],
    required: true,
    isFullWidth: false,
  },

  {
    inputType: "selectInput",
    name: "state",
    prompt: "Select State",
    options: [stateOptions],
    required: true,
    isFullWidth: false,
  },
];

// *************  DRF admin Table Data *********
export const TableKeys = ["Name", "Role", "Email", "Status"];

export const TableHeaders = ["Name", "Role", "Email", "Status"];

export const TableData = [
  {
    id: "1",
    Name: { type: "string", value: "Tech Innovations Ltd." },
    Role: { type: "string", value: "1234567890" },
    Email: { type: "string", value: "martins@com" },
    Status: {
      type: "string",
      value: "approved",
      jsx: (
        <div className="status-approved">
          <span className="status-dot approved" /> Approved
        </div>
      ),
    },
  },
  {
    id: "2",
    Name: { type: "string", value: "Greenfield Farms" },
    Role: { type: "string", value: "9876543210" },
    Email: { type: "string", value: "Agriculture" },
    Status: {
      type: "string",
      value: "approved",
      jsx: (
        <div className="status-approved">
          <span className="status-dot approved" /> Pending
        </div>
      ),
    },
  },
  {
    id: "3",
    Name: { type: "string", value: "InnovateTech" },
    Role: { type: "string", value: "4567891230" },
    Email: { type: "string", value: "Software Development" },
    Status: {
      type: "string",
      value: "declined",
      jsx: (
        <div className="status-declined">
          <span className="status-dot declined" /> Declined
        </div>
      ),
    },
    // dateSubmitted: { type: "string", value: "2025-06-10" },
  },
];
